import { SettingsFixedPriorities } from '@viamap/viamap2-common';
import { useContext, useEffect, useReducer, useState } from "react";
import { MapCommandType, MapCommand, AppMode } from "src/common/managers/Types";
import MapScreen from './MapScreen';
import { SettingsManager } from '@viamap/viamap2-common';
import { GenericTransactionManager, MapitStateActions, MapitStateContext, MapitStateReducer, initialMapitState, transactionalMapitStateReducer } from 'src/states/MapitState';
import FileImporter from './FileImporter';
import { ApplicationStateContext, Feature, actionSetAppMode, actionUpdateAvailableFeatures } from 'src/states/ApplicationState';
import { LayerContainer } from './LayerContainer';
import { WindowManager } from 'src/WindowManager/WindowManager';
import { QuickOrthoPhoto } from './QuickOrthoPhoto';
import { WindowDisplayer } from 'src/WindowManager/WindowDisplayer';
import { DeepLinkNavigationBar } from './DeepLinkNavigationBar';
import variant from "../mit-product-variant-settings.json"



export function DeepLinkManager(props: { children: JSX.Element }) {
  let [link, setLink] = useState("")
  let [commandList, setCommandList] = useState<MapCommand[]>([])
  const { dispatch: applicationDispatch } = useContext(ApplicationStateContext)
  const [MapitStateState, MapitStateDispatch] = useReducer(MapitStateReducer, initialMapitState(document.body.clientWidth > 900));

  const [showLayerList, setShowLayerList] = useState(false)

  useEffect(() => {
    if (!showLayerList) {
      const event = (ev: TouchEvent) => {
        if (ev.touches[0].clientX > document.body.clientWidth - 10) {
          ev.preventDefault?.()
          // ev.stopPropagation?.()
          // ev.stopImmediatePropagation?.()

          let cX = ev.touches[0].clientX
          let cY = ev.touches[0].clientY

          const stopEvent = (ev: TouchEvent) => {
            let csX = ev.changedTouches[0].clientX
            let csY = ev.changedTouches[0].clientY
            if (Math.abs(cX - csX) > 2 * Math.abs(cY - csY) && cX > csX) {
              setShowLayerList(true)
            }
            window.removeEventListener("touchend", stopEvent)
          }
          window.addEventListener("touchend", stopEvent, { passive: false })
          return false
        }
      }
      window.addEventListener("touchstart", event, { passive: false })
      return () => {
        window.removeEventListener("touchstart", event)
      }
    } else {
      const event = (ev: TouchEvent) => {
        let offset = document.getElementsByClassName("Sidebar-Right")[0].clientLeft
        if (ev.touches[0].clientX > offset) {
          let cX = ev.touches[0].clientX
          let cY = ev.touches[0].clientY

          const stopEvent = (ev: TouchEvent) => {
            let csX = ev.changedTouches[0].clientX
            let csY = ev.changedTouches[0].clientY
            if (Math.abs(cX - csX) > 2 * Math.abs(cY - csY) && cX < csX && Math.abs(cX - csX) > 50) {
              setShowLayerList(false)
            }
            window.removeEventListener("touchend", stopEvent)
          }
          window.addEventListener("touchend", stopEvent, { passive: false })
        }
      }
      window.addEventListener("touchstart", event, { passive: false })
      return () => {
        window.removeEventListener("touchstart", event)
      }
    }
  }, [showLayerList])


  useEffect(() => {
    let params = new URL(window.location.href).searchParams;
    let mapRef = params.get("mapdef");
    let embeddedMode = params.has('embeddedmode') && (params.get('embeddedmode') !== "0" && params.get('embeddedmode') !== "false");

    // let readOnlyMapData = {}


    if (mapRef) {
      // Store user values to user sesion
      let userRoles = ["Basic", "DeviceLocation", "POI"];

      // expand features from the roles, such that we can add individual features as required
      setLink(mapRef)
      if (SettingsManager.getSystemSetting("shortLinks", false)) {

      } else {
        mapRef = (mapRef && Array.isArray(mapRef)) ? mapRef[0] : mapRef;
        var newURL = location.href.split("?")[0];
        window.history.pushState('object', document.title, newURL);
      }
      if (params.get("bgmode")) {
        let mode = parseInt(params.get("bgmode")!);
        const allowedModes = [
          Feature.BackgroundLayerCadaster, //1 
          Feature.BackgroundLayerCadasterPoints, //2 
          Feature.BackgroundLayerLocalPlans, //4 
          Feature.BackgroundLayerZoning, //8 
          Feature.BackgroundLayerDAI, // 16 
          Feature.MapStyleAerial, // 32 
          Feature.BackgroundLayerJordforureningV1, //64 
          Feature.BackgroundLayerJordforurening_NuanceringV2 // 128 
        ]
        let i = 0;
        while (mode > 0) {
          if (mode & 1) {
            console.info(allowedModes[i])
          }
          mode = mode >> 1
          i += 1
        }
      }
      applicationDispatch(actionUpdateAvailableFeatures(userRoles));
      applicationDispatch(actionSetAppMode(AppMode.ReadOnly));

    } else {
      if (params.get("ejerlav") && params.get("matrnr")) {
        setLink("Matrikel Opslag")
        setCommandList([{
          cmd: MapCommandType.DisplayCadaster,
          params: [params.get("ejerlav") ?? "", params.get("matrnr") ?? ""] as [string, string]
        }]);
        let userRoles = ["Basic", "DeviceLocation", "POI"]
        applicationDispatch(actionUpdateAvailableFeatures(userRoles));
        applicationDispatch(actionSetAppMode(AppMode.ReadOnly));

      }
    }
    if (embeddedMode) {
      applicationDispatch(actionSetAppMode(AppMode.Embedded));
    }
  }, [])

  if (link === "" && !commandList.length) {
    return props.children
  }
  return (
    <WindowManager>
      <DeepLinkVariantSetter />
      <MapitStateContext.Provider
        value={{
          state: MapitStateState,
          dispatch: GenericTransactionManager.dispatchMiddleware<MapitStateActions>(MapitStateDispatch, transactionalMapitStateReducer),
        }}
      >
        <FileImporter >
          <div id='Mit-ApplicationOverlay' >

            <DeepLinkNavigationBar onCollapse={() => setShowLayerList((a) => !a)} />
            <div id='Mit-NonBlockingOverlay' style={{ zIndex: 1 }}>
              <LayerContainer show={showLayerList} />
              <div id='Mit-MapOverlay'>
                <WindowDisplayer />
                <QuickOrthoPhoto />
              </div>
            </div>
          </div>
          <MapScreen callbackToLogout={() => console.info("User not Logged in")}
            callBackMap={() => console.info("callBackMap")}
            showTrialSignupDialog={false}
            callBackOnTrialSignup={() => console.info("callBackTrialSignup")}
            mapReference={link}
            commandList={commandList}
          />
          {/* </div> */}
        </FileImporter>
      </MapitStateContext.Provider>
    </WindowManager>
  )
}

function DeepLinkVariantSetter() {

  function isExplore() {
    let location = window.location;
    if (location.hostname.includes("explorer")
      || location.hostname.includes("estate")
      || location.search.includes("explorer") // for testing add &explorer to URL or ?explore"
    ) {
      return true
    }
    return false
  }

  useEffect(() => {
    isExplore() && SettingsManager.addSettings(variant["Explorer"], { filename: "explore theme", priority: SettingsFixedPriorities.ProductVariantSettings })
  }, []);

  return (<></>)
}